/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetLastOdometerResponse } from '../models/ApiResponseGetLastOdometerResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class OdometerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 월별 주행 기록 조회
   * 차량의 월별 주행 기록을 조회합니다.
   * @returns ApiResponseGetLastOdometerResponse OK
   * @throws ApiError
   */
  public getOdometer({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetLastOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/odometer',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
  /**
   * 월별 주행 기록 조회
   * 차량의 월별 주행 기록을 조회합니다.
   * @returns ApiResponseGetLastOdometerResponse OK
   * @throws ApiError
   */
  public getOdometer1({
    authorization,
    vin,
    ccId,
  }: {
    authorization?: string,
    vin: string,
    ccId: string,
  }): CancelablePromise<ApiResponseGetLastOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/odometer/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'ccId': ccId,
      },
    });
  }
}
